export default __webpack_public_path__ + "static/media/Tulip Elastics (P) Limited.790f6290.jpg";